import React from 'react'
import LoadingWrapper from '../../components/LoadingWrapper'

const SidebarFilter = ({
    promiseArea,
    filters,
    selectedFilter,
    selectedFilterChange,
    headerText = 'Filter By:',
    ...props
}) => (
    <div id="blog-categories" {...props}>
        <h4>{headerText}</h4>
        <LoadingWrapper area={promiseArea}>
            <ul>
                {filters.map((filter) => {
                    const {
                        sys: { id },
                        fields: { name },
                    } = filter
                    return (
                        <li key={id}>
                            <span
                                onClick={() => {
                                    if (selectedFilter !== name) {
                                        selectedFilterChange(name)
                                    } else {
                                        selectedFilterChange('')
                                    }
                                }}
                                className={name === selectedFilter ? 'active' : null}
                            >
                                {name}
                            </span>
                        </li>
                    )
                })}
            </ul>
        </LoadingWrapper>
    </div>
)

export default SidebarFilter
